import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';
import { SessionSchema } from 'app/schemas';
import { DD_IGNORED_MESSAGES } from 'config/constants';
import { DD_CLIENT_TOKEN, DD_RUM_CLIENT_TOKEN } from 'config/environment';
import { formattedDisplayName } from 'utils/formatting';
import packageJson from '../../package.json';

export function bootDatadogRUM(session?: SessionSchema) {
  try {
    if (!session || import.meta.env.VITE_DISABLE_VENDORS === 'true') {
      return datadogRum.stopSession();
    }
    const version = packageJson.version;
    datadogRum.init({
      applicationId: '97e212fd-beeb-4d6b-8074-a285ba1e3277',
      clientToken: DD_RUM_CLIENT_TOKEN,
      site: 'datadoghq.com',
      service: 'ce-app-blue-whale',
      sessionSampleRate: 100,
      sessionReplaySampleRate: 0,
      trackResources: true,
      trackLongTasks: true,
      trackUserInteractions: true,
      defaultPrivacyLevel: 'mask-user-input',
      allowedTracingUrls: [
        /https:\/\/.*\.saleswhale\.com/,
        /https:\/\/.*\.6sense\.com/,
        /https:\/\/.*\.6si\.com/,
      ],
      env: import.meta.env.VITE_APP_ENV || 'local',
      version,
    });
    datadogRum.setUser({
      id: session.userId.toString(),
      email: session.email,
      name: formattedDisplayName(session.firstName, session.lastName),
    });
    datadogRum.setGlobalContextProperty('teamData', {
      team: session.currentTeam.name,
      teamId: session.currentTeam.id,
    });
  } catch {
    //catch in case dd doesn't exist
    return;
  }
}
export function invalidateDatadog() {
  try {
    datadogRum.clearGlobalContext();
    datadogRum.clearUser();
  } catch {
    return;
  }
}

export function bootDatadogLogger() {
  try {
    if (import.meta.env.VITE_DISABLE_VENDORS === 'true') {
      return;
    }
    const version = packageJson.version;
    datadogLogs.init({
      clientToken: DD_CLIENT_TOKEN,
      site: 'datadoghq.com',
      service: 'ce-app-blue-whale',
      forwardErrorsToLogs: true,
      sessionSampleRate: 100,
      env: import.meta.env.VITE_APP_ENV || 'local',
      version: version,
      beforeSend: log => {
        const isIgnoredMessage =
          log.stats === 'error' &&
          DD_IGNORED_MESSAGES.some(ignored => log.message.includes(ignored));
        const isLogRocketIssue =
          log.http && log.http.status_code === 0 && log.http.url.includes('lr-in-prod');
        // ignore ignoredMessages list and logrocket issues
        return !isIgnoredMessage && !isLogRocketIssue;
      },
    });
  } catch {
    //catch in case dd doesn't exist
    return;
  }
}
